import type { ClubType } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';

import type { InitialState } from './interfaces';

const DEFAULT_SHIPPING_ADDRESS = {
  id: 0,
  email: '',
  customerRut: '',
  region: 0,
  commune: '',
  streetName: '',
  alias: '',
  firstName: '',
  lastName: '',
  phone: ''
};

export const CART_INITIAL_STATE: InitialState = {
  data: {
    id: '',
    anonymousId: '',
    deliveryInfo: undefined,
    lineItems: [],
    productOptions: [],
    totalLineItemQuantity: 0,
    totalPrice: {
      centAmount: 0,
      currencyCode: 'CLP'
    },
    shippingAddress: DEFAULT_SHIPPING_ADDRESS,
    discountCodes: [],
    directDiscounts: [],
    customerTags: [],
    source: '',
    clubParisCodeType: '' as ClubType,
    weddingFirstName1: '',
    weddingFirstName2: '',
    customCartType: ''
  },
  isLoading: undefined,
  onBehalf: []
};

export default {
  CART_INITIAL_STATE
};
